var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g, _g2, _g3, _g4, _path67, _g5, _g6, _path68, _path69, _path70, _g7, _path71, _g8, _g9, _g0, _g1, _g10, _g11, _path72;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 226.76 377.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M726.02,363.56c12.8-10.94,25.55-23.13,38-42,36.27-53.56,42.55-121.85,69.56-222.67,13.2-49.26,28.08-69.16,50.67-138.67,20.67-63.61,48.67-115.89,55.78-230.28",
    fill: "none",
    stroke: "#7db5a9",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M807.91,303.22c-15.78,4.22-32.67,14-46.89,23.78",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M750.8,282.78c5.56,12.89,8.22,32.67,2,53.11",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M833.91,230.33c-13.78,6.44-31.78,19.11-40.89,32.89",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M852.68,171.11c-14.06,4.89-37.44,25-45.39,39.39",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M871.24,104.22c-15.11,4.44-42.77,30.02-50.89,45.33",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M828.71,10.93c6.22,13.11,12.44,38,13.33,56.44",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M797.38,103.38c7.76,11.69,20.15,44.64,19.56,64.44",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M776.13,186.11c6.89,22.22,20.67,40.22,17.78,70",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M779.57,315.11c30.47,3.78,52.71-7.06,64.89-29.33-26.56-3.63-49.23,6.57-64.89,29.33Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M756.68,312.33c-17.22-15.94-24.89-42.72-16.78-75.39,22.78,26.67,26.11,54.56,16.78,75.39Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M812.46,243.33c30.47,3.78,47.78-15.56,54.67-33.33-26.67.67-43.56,10.67-54.67,33.33Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M915.71-2.62c-14.17.83-46.56,18.56-55.67,32.33",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M932.78-88.91c-14.94,7.73-35.89,25.23-44.74,36.62",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M891.05,6.21c32.83,8.83,52.61-4.72,59.5-22.5-25.83-2.17-48.39-.17-59.5,22.5Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M526.05,92.04c-15.51,7.89-36.37,25-39.76,34.92",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M505.45,105.73c24.93,1.87,45.07-20.23,47.6-34.02-18.96,1.99-42.69,16.12-47.6,34.02Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M168.29,67.92c19.32-15.86,18.64-45.75,10.95-57.47-12.34,14.53-19.76,41.13-10.95,57.47Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M186.79,103.31c-11.9,7.87-27.3,23.76-29.14,32.16",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M171.28,116.37c20.49-.8,34.84-20.68,35.61-32.15-15.26,3.39-33.28,17.11-35.61,32.15Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M553.38,10.71c-15.51,7.89-36.37,25-39.76,34.92",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M532.78,24.39c24.93,1.87,45.07-20.23,47.6-34.02-18.96,1.99-42.69,16.12-47.6,34.02Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M561.14-71.28c-10.25,9.46-22.64,27.19-23.1,35.59",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M548.22-56.25c19.65-3.98,30.39-25.4,29.35-36.59-14.2,5.65-29.44,21.71-29.35,36.59Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M965.19-190.31c-12.66,3.81-34.81,21.26-41.14,32.69",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M947.03-179.8c24.47,6.87,40.37-10.6,43.64-26.31-20.67,2.02-38.16,6.84-43.64,26.31Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M958.98-237.68c-7.61,5.64-21.6,24.39-24.43,33.89",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M948.42-223.74c21.58-7.05,29.1-25.6,26.46-38.05-15.23,8.22-28.52,21.32-26.46,38.05Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M787.68,215.67c-23-17.33-33-51.67-27.67-75.67,30.67,30.33,33.67,56,27.67,75.67Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M866.47-66.09c5.16,16.64,9.49,32.4,7.33,54.7",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M913.28-221.57c6.39,14.63,12.85,34.79,10.29,57.74",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M890.71-136.4c6.39,14.63,12.09,29.62,9.53,52.57",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M872.46-41.61c-17.23-12.98-22.66-44.25-18.67-62.22,22.97,22.72,23.16,47.49,18.67,62.22Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M367.27,368.49c12.8-10.94,35.64-27.17,48.08-46.04,36.27-53.56,47.76-118.56,76.25-218.96,14-49.33,60-118,47.01-198.91",
    fill: "none",
    stroke: "#7db5a9",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M13.81,368.59c79.1-41.85,121.4-149.58,142.42-232.27,7.44-30.33,12.86-61.2,15.43-92.31.08-.96.92-1.67,1.87-1.59.96.08,1.67.91,1.59,1.87-2.46,31.35-7.78,62.41-15.15,92.95-21.01,84.13-63.5,192.97-143.9,235.81-2.91,1.38-5.26-2.79-2.26-4.46h0Z",
    fill: "#7db5a9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M459.24,304.11c-16.58,3.6-33.31,13.5-46.89,23.78",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M400.6,293.82c2.92,13.43,6.04,26.04,0,45.33",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M485.24,231.22c-13.78,6.44-31.78,19.11-40.89,32.89",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M511.49,166.6c-12.12.62-39.86,29.64-48.44,44",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M108.13,191.44c6.89,22.22,16.11,23.33,13.22,53.11",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M483.46,43c6.89,22.22,14.03,24.04,11.14,53.82",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M517.8-30.67c6.89,22.22,8.36,24.71,5.47,54.49",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M430.91,316c30.47,3.78,52.71-7.06,64.89-29.33-26.56-3.63-49.23,6.57-64.89,29.33Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M130.8,286.78c-16.58,3.6-33.31,13.5-46.89,23.78",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M102.46,298.67c30.47,3.78,52.71-7.06,64.89-29.33-26.56-3.63-49.23,6.57-64.89,29.33Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M-242.96,303.67c-15.96,3.46-32.07,12.99-45.14,22.89",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M-270.23,315.11c29.34,3.64,50.74-6.79,62.46-28.24-25.57-3.5-47.39,6.32-62.46,28.24Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M403.94,321.15c-16.52-24.24-22.51-38.78-12.93-68.81,20.91,27.09,23.04,48.96,12.93,68.81Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6,276.93c2.92,13.43,6.04,26.04,0,45.33",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M75.94,304.27c-16.52-24.24-22.51-38.78-12.93-68.81,20.91,27.09,23.04,48.96,12.93,68.81Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M-296.82,300.16c2.23,10.26,4.61,19.89,0,34.64",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M-294.27,321.04c-12.62-18.52-17.2-29.63-9.88-52.57,15.97,20.7,17.6,37.41,9.88,52.57Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M463.8,244.22c30.47,3.78,47.78-15.56,54.67-33.33-26.67.67-43.56,10.67-54.67,33.33Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M167.01,191.86c-13.29,7.39-30.36,21.29-38.49,35.67",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M146.53,206.33c30.66,1.64,46.57-18.86,52.2-37.07-26.55,2.53-42.7,13.68-52.2,37.07Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M-259.84,278.29c25.4-17.26,25.65-43.21,19.1-61.11-19.6,18.09-25.7,36.75-19.1,61.11Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M119.68,221c-23-17.33-33-51.67-27.67-75.67,30.67,30.33,33.67,56,27.67,75.67Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M429.46,219c6.89,22.22,16.11,23.33,13.22,53.11",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M441.02,248.56c-23-17.33-33-51.67-27.67-75.67,30.67,30.33,33.67,56,27.67,75.67Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M453.73,147.04c5.97,12.06,13.12,21.51,14.2,38.78",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M448.4,97.26c5.94,7.86,17.76,29.34,16.43,54.23",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M480.07-8.74c5.94,7.86,12.96,32.26,14.09,56.01",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M463.04,162.86c-14.72-7.79-23.58-26.48-22.74-40.67,20.3,14.51,24.36,28.89,22.74,40.67Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M490.93,63.04c-17.43-6.7-25.04-32.63-21.63-47.86,24.09,15.19,26.07,36.58,21.63,47.86Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M141.33,117.03c4.39,22.85,11.29,25.45,5.13,54.72",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M146.55,137.78c-16.58-8.59-21.28-35.2-16.21-49.96,22.27,17.76,21.87,39.24,16.21,49.96Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M522.59-11.58c-14.04-8.37-17.84-33.59-13.43-47.46,18.8,17.12,18.32,37.41,13.43,47.46Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M868.23,107.54",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M889.37,64.9",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.96,91.61l-1.67-25.67c-12.5-16.5-32.83-.17-22.17,13.83l23.83,11.83Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.15,92.1l21.39-14.28c8.04-19.08-16.27-28.52-23.06-12.28l1.67,26.56Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.6,104.78",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.65,91.95l23.08,11.36c20.54-2.6,16.52-28.37-.93-26.11l-22.14,14.75Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.14,91.87l1.7,25.66c12.52,16.48,32.83.12,22.15-13.86l-23.85-11.8Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.63,92.02l-21.46,14.18c-8.13,19.04,16.14,28.59,23.01,12.39l-1.55-26.56Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.96,91.61l-23.01-11.5c-20.55,2.48-16.69,28.27.78,26.12l22.23-14.62Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 889.3,
    y1: 91.72,
    x2: 876.07,
    y2: 93.28,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.37,92.36l-13.01,3.32c-3.58.72-4.22-4.67-.56-4.8,0,0,13.43.21,13.43.21.74,0,.87,1.1.15,1.27h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 890.74,
    y1: 90.39,
    x2: 882.8,
    y2: 80.01,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.23,90.78l-9.35-9.3c-2.47-2.69,1.88-6.03,3.84-2.93,0,0,6.53,11.45,6.53,11.45.38.63-.52,1.31-1.02.78h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 890.63,
    y1: 90.83,
    x2: 885.25,
    y2: 105.13,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.23,91.06l-3.72,14.92c-1.03,3.43-6.01,1.56-4.52-1.7,0,0,7.04-13.67,7.04-13.67.34-.67,1.39-.27,1.2.45h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 891.52,
    y1: 92.17,
    x2: 900.91,
    y2: 104.35,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.02,91.78l10.8,11.1c2.38,2.66-1.85,5.94-3.82,2.95,0,0-7.99-13.27-7.99-13.27-.39-.64.5-1.32,1.01-.78h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 891.63,
    y1: 90.28,
    x2: 898.58,
    y2: 78.9,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.08,89.94l5.44-12.3c1.64-3.26,6.27-.43,4.12,2.52,0,0-8.47,10.45-8.47,10.45-.45.58-1.41,0-1.09-.67h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 893.52,
    y1: 91.17,
    x2: 906.41,
    y2: 91.72,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.54,90.53l12.97-1.22c3.66-.16,3.43,5.3-.21,4.82,0,0-12.81-2.33-12.81-2.33-.73-.12-.68-1.22.06-1.28h0Z",
    fill: "#7db5a9"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M952.98-130.21",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.57-103.5l-1.67-25.67c-12.5-16.5-32.83-.17-22.17,13.83l23.83,11.83Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.76-103.01l21.39-14.28c8.04-19.08-16.27-28.52-23.06-12.28l1.67,26.56Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.21-90.33",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.27-103.16l23.08,11.36c20.54-2.6,16.52-28.37-.93-26.11l-22.14,14.75Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.75-103.24l1.7,25.66c12.52,16.48,32.83.12,22.15-13.86l-23.85-11.8Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.24-103.09l-21.46,14.18c-8.13,19.04,16.14,28.59,23.01,12.39l-1.55-26.56Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.57-103.5l-23.01-11.5c-20.55,2.48-16.69,28.27.78,26.12l22.23-14.62Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 952.91,
    y1: -103.39,
    x2: 939.68,
    y2: -101.83,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.98-102.75l-13.01,3.32c-3.58.72-4.22-4.67-.56-4.8,0,0,13.43.21,13.43.21.74,0,.87,1.1.15,1.27h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 954.35,
    y1: -104.72,
    x2: 946.41,
    y2: -115.1,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.84-104.33l-9.35-9.3c-2.47-2.69,1.88-6.03,3.84-2.93,0,0,6.53,11.45,6.53,11.45.38.63-.52,1.31-1.02.78h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 954.24,
    y1: -104.28,
    x2: 948.86,
    y2: -89.99,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.84-104.05l-3.72,14.92c-1.03,3.43-6.01,1.56-4.52-1.7,0,0,7.04-13.67,7.04-13.67.34-.67,1.39-.27,1.2.45h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 955.13,
    y1: -102.94,
    x2: 964.52,
    y2: -90.76,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.63-103.33l10.8,11.1c2.38,2.66-1.85,5.94-3.82,2.95,0,0-7.99-13.27-7.99-13.27-.39-.64.5-1.32,1.01-.78h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 955.24,
    y1: -104.83,
    x2: 962.19,
    y2: -116.21,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.69-105.17l5.44-12.3c1.64-3.26,6.27-.43,4.12,2.52,0,0-8.47,10.45-8.47,10.45-.45.58-1.41,0-1.09-.67h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 957.13,
    y1: -103.94,
    x2: 970.02,
    y2: -103.39,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.16-104.58l12.97-1.22c3.66-.16,3.43,5.3-.21,4.82,0,0-12.81-2.33-12.81-2.33-.73-.12-.68-1.22.06-1.28h0Z",
    fill: "#7db5a9"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M867.17-188.81",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.53-164.33l-6.24-23.5c-14.61-13.02-30.49,5.85-18.03,16.88l24.27,6.62Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.79-163.91l17.24-17.15c3.97-19.16-20.31-23.48-23.64-7.18l6.4,24.33Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.71-156.8",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.16-164.33l23.48,6.32c18.57-6.17,10.14-29.34-5.64-24.05l-17.84,17.73Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.66-164.31l6.27,23.5c14.63,13,30.48-5.89,18.01-16.91l-24.28-6.59Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.29-163.89l-17.32,17.07c-4.06,19.15,20.2,23.57,23.6,7.29l-6.29-24.36Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.53-164.33l-23.44-6.46c-18.61,6.06-10.32,29.28,5.49,24.09l17.95-17.63Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 872,
    y1: -163.92,
    x2: 860.02,
    y2: -160.07,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.2-163.32l-11.44,5.55c-3.39,1.43-5.07-3.78-1.48-4.6,0,0,12.53-2.17,12.53-2.17.72-.13,1.05.91.39,1.22h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 873.1,
    y1: -165.43,
    x2: 863.84,
    y2: -173.6,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.67-164.95l-10.43-6.84c-2.98-2.18.66-6.31,3.2-3.62,0,0,8.08,9.5,8.08,9.5.49.54-.26,1.37-.85.96h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 873.07,
    y1: -164.99,
    x2: 870.69,
    y2: -150.75,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.71-164.89l-.63,14.53c-.33,3.59-5.62,2.72-4.76-.8,0,0,4.13-13.95,4.13-13.95.21-.72,1.3-.53,1.26.21h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 874.14,
    y1: -163.92,
    x2: 885.08,
    y2: -154.34,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.56-164.4l12.11,8.25c2.89,2.15-.66,6.21-3.18,3.63,0,0-9.77-10.92-9.77-10.92-.51-.54.25-1.39.84-.96h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 873.9,
    y1: -165.69,
    x2: 878.27,
    y2: -177.51,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.3-165.91l2.7-12.44c.96-3.55,6.11-1.65,4.53,1.67,0,0-6.03,11.21-6.03,11.21-.34.65-1.36.27-1.2-.44h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 875.82,
    y1: -165.21,
    x2: 887.87,
    y2: -167.05,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.72-165.84l11.79-3.59c3.59-.89,4.42,4.55.73,4.77,0,0-12.33.09-12.33.09-.73.01-.89-1.06-.19-1.26h0Z",
    fill: "#7db5a9"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M799.53-43.79",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.84-18.36l-8.12-24.41c-16.27-12.79-31.8,8.16-17.94,19l26.05,5.41Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.15-17.93l17.08-19.23c2.94-20.49-22.97-23.46-25.42-6.03l8.35,25.27Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.98-12.12",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.57-18.46l25.2,5.14c19.2-7.73,8.79-31.64-7.52-25.02l-17.68,19.89Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.04-18.41l8.15,24.39c16.29,12.77,31.79-8.21,17.91-19.03l-26.06-5.37Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.63-17.88l-17.17,19.16c-3.04,20.48,22.86,23.57,25.39,6.15l-8.23-25.3Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.84-18.36l-25.17-5.29c-19.25,7.61-8.98,31.58,7.37,25.07l17.8-19.78Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 806.26,
    y1: -17.83,
    x2: 793.86,
    y2: -12.97,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.49-17.23l-11.75,6.51c-3.28,1.61-5.26-3.45-1.76-4.5,0,0,13.04-3.2,13.04-3.2.72-.18,1.12.84.47,1.19h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 807.32,
    y1: -19.48,
    x2: 797.01,
    y2: -27.51,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.93-18.98l-11.4-6.62c-3.07-1.99.27-6.3,2.97-3.81,0,0,9.22,9.42,9.22,9.42.53.51-.17,1.39-.79,1.01h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 807.32,
    y1: -19.02,
    x2: 805.74,
    y2: -3.83,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.96-18.96l.18,15.37c-.13,3.58-5.42,3.04-4.8-.5,0,0,3.35-15.01,3.35-15.01.16-.73,1.27-.62,1.27.13h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 808.52,
    y1: -17.96,
    x2: 820.7,
    y2: -8.56,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.91-18.47l13.26,8c2.98,1.99-.27,6.2-2.95,3.82,0,0-11.09-10.81-11.09-10.81-.55-.51.16-1.41.78-1.01h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 808.15,
    y1: -19.81,
    x2: 811.99,
    y2: -32.58,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.54-20l2.14-13.28c.76-3.57,5.96-2.01,4.62,1.39,0,0-5.54,12.25-5.54,12.25-.3.68-1.35.36-1.22-.37h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 810.2,
    y1: -19.43,
    x2: 822.81,
    y2: -22.16,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.07-20.06l12.23-4.46c3.5-1.08,4.66,4.25,1.02,4.72,0,0-12.98.99-12.98.99-.73.06-.96-1.01-.27-1.25h0Z",
    fill: "#7db5a9"
  })))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M925.05,60.38c4.21,1.19,14.98-13.68,13.86-25.79-.12-1.3-1.57-2.1-2.85-2.09-7.35.04-16.44,7.9-22.67,14.88",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M863.3,173.21c3.65,4.28,20.08-2.13,24.3-16.08.37-1.21-.66-2.35-1.75-2.97-7.23-4.16-20.88-.89-28.05,5.22",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 852.68,
    y1: 171.11,
    x2: 871.13,
    y2: 163.06,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.48,170.65c4.27-5.26,11.62-8.82,18.44-8.06.32.05.54.35.5.67-3.64,5.64-11.99,8.8-18.54,8.3-.43-.04-.67-.58-.4-.92h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 851.9,
    y1: 170.98,
    x2: 867.82,
    y2: 150.89,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.51,170.67c.72-8.81,7.2-17.77,15.92-20.1.34-.08.68.13.77.47-.08,8.99-7.53,17.58-15.9,20.25-.4.12-.81-.21-.78-.62h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 852.22,
    y1: 172.31,
    x2: 878.27,
    y2: 174.82,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.26,171.81c7.99-3.51,19.02-2.88,26.06,2.51.26.21.3.59.09.84-7.65,4.22-19.25,2.57-26.25-2.36-.35-.25-.29-.82.1-1h0Z",
    fill: "#7db5a9"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M519.77,166.64c3.65,4.28,20.08-2.13,24.3-16.08.37-1.21-.66-2.35-1.75-2.97-7.23-4.16-20.88-.89-28.05,5.22",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 509.16,
    y1: 164.54,
    x2: 527.6,
    y2: 156.49,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.96,164.08c4.27-5.26,11.62-8.82,18.44-8.06.32.05.54.35.5.67-3.64,5.64-11.99,8.8-18.54,8.3-.43-.04-.67-.58-.4-.92h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 508.38,
    y1: 164.41,
    x2: 524.3,
    y2: 144.32,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.99,164.1c.72-8.81,7.2-17.77,15.92-20.1.34-.08.68.13.77.47-.08,8.99-7.53,17.58-15.9,20.25-.4.12-.81-.21-.78-.62h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 508.69,
    y1: 165.74,
    x2: 534.75,
    y2: 168.26,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.74,165.25c7.99-3.51,19.02-2.88,26.06,2.51.26.21.3.59.09.84-7.65,4.22-19.25,2.57-26.25-2.36-.35-.25-.29-.82.1-1h0Z",
    fill: "#7db5a9"
  })))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M911.77,62.08c1.83-6.66,7.22-13.11,13.86-15.34.31-.09.64.08.73.39-1.04,6.7-7.62,13.3-13.85,15.62-.41.15-.85-.25-.74-.67h0Z",
    fill: "#7db5a9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M910.88,62.5c-2.87-8.58-.52-19.78,6.54-25.72.27-.22.66-.17.88.1,2.82,6.83,1.24,13.92-1.99,20.16-.31.65-4.55,7.43-5.44,5.46h0Z",
    fill: "#7db5a9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M912.04,63.28c5.99-6.5,16.56-10.5,25.31-8.48.32.08.51.41.43.72-5.37,7.01-16.91,10.31-25.42,8.7-.42-.08-.6-.63-.32-.95h0Z",
    fill: "#7db5a9"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M768.27,82.93",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.93,52.71c-3.11,9.7-2.96,20,.44,30.89,3.16.53,6.57,1.95,10.22,4.22l1.67-9.78c2.09.96,4.51,2.98,7.11,5.56,1.76-1.18,3-6.12,4.22-11.22-5.83-8.43-13.51-15.17-23.67-19.67Z",
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.27,82.93c11.92,1.55,17.92,6.82,28.89,20.17.08.09,0,.24-.12.22-9.87-1.49-21.96-9.19-28.77-20.4Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.16,86.27c.38-7.1,1.56-13.08,4.44-16.67,5.92,9.35,4.73,20.75.02,33.15-.05.13-.24.1-.25-.04-.15-9.92-3.65-18.49-13.11-24.66-1.29,3.14-1.47,6.78-1.11,10.67",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.27,83.6c-2.56-11.01-3.04-22.09-.11-30.89,8.4,2.24,18.36,10.03,24.22,18.83",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M905.71-22.12c-5.3,6.33-25,16.17-32.83,17",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M915.73-23.35c5.04,2.51,17.64-9.84,16.05-24.33-.14-1.25-1.52-1.9-2.78-2.05-8.29-.99-19.55,7.37-23.76,15.81",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 905.15,
    y1: -21.12,
    x2: 918.95,
    y2: -35.76,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.79-21.46c1.86-6.51,7.22-12.67,13.8-14.65.32-.08.64.11.72.42-1.11,6.58-7.61,12.82-13.8,14.91-.41.14-.84-.27-.73-.69h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 904.38,
    y1: -20.93,
    x2: 911.14,
    y2: -45.66,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.9-21.06c-2.79-8.38-.35-19.17,6.75-24.73.28-.21.68-.15.89.13,3.45,8.35-.01,19.08-6.68,24.87-.32.27-.83.13-.96-.26h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 905.19,
    y1: -19.83,
    x2: 930.15,
    y2: -27.74,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.04-20.3c5.93-6.35,16.41-10.12,24.96-7.91.32.09.5.42.41.74-5.38,6.88-16.69,9.91-25.07,8.13-.42-.09-.59-.64-.3-.95h0Z",
    fill: "#7db5a9"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M914.6-232.59c4.37-3.75-2.27-20.51-16.56-24.75-1.24-.37-2.4.68-3.04,1.8-4.23,7.41-.82,21.33,5.46,28.64",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 912.5,
    y1: -221.74,
    x2: 904.18,
    y2: -240.55,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.05-221.54c-5.34-4.38-9-11.83-8.32-18.8.04-.32.34-.55.66-.5,5.7,3.68,9,12.27,8.58,18.9-.03.44-.57.67-.91.4h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 912.38,
    y1: -220.95,
    x2: 891.75,
    y2: -237.11,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.07-220.55c-8.92-.77-18.14-7.37-20.63-16.17-.09-.34.11-.68.45-.77,9.14.12,17.94,7.68,20.8,16.15.13.4-.2.82-.62.79h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 913.73,
    y1: -221.27,
    x2: 916.19,
    y2: -247.9,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.24-221.32c-3.53-8.12-2.92-19.42,2.46-26.63.2-.26.58-.3.84-.1,4.25,7.76,2.61,19.67-2.3,26.83-.25.35-.82.3-1-.09h0Z",
    fill: "#7db5a9"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M483.03-15.5c4.93-2.98,1.17-20.6-12.22-27.16-1.16-.57-2.48.27-3.29,1.27-5.4,6.61-4.35,20.9.63,29.15",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 479.15,
    y1: -5.15,
    x2: 474.07,
    y2: -25.08,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.67-5.03c-4.54-5.2-6.91-13.16-5.09-19.93.1-.31.42-.48.73-.39,5.01,4.58,6.83,13.59,5.32,20.07-.1.43-.68.57-.97.25h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 478.9,
    y1: -4.39,
    x2: 461.24,
    y2: -23.76,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.53-4.05c-8.67-2.24-16.66-10.28-17.66-19.37-.03-.35.23-.65.57-.68,7.2,1.35,12.19,6.49,15.57,12.56.37.61,3.64,7.84,1.52,7.48h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 480.29,
    y1: -4.48,
    x2: 487.13,
    y2: -30.34,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.81-4.61c-2.13-8.6.35-19.64,6.84-25.86.24-.22.62-.2.84.04,2.33,6.9.47,13.98-2.55,20.26-.34.66-4.28,7.64-5.13,5.56h0Z",
    fill: "#7db5a9"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M450.27,90.15c4.37-3.75-2.27-20.51-16.56-24.75-1.24-.37-2.4.68-3.04,1.8-4.23,7.41-.82,21.33,5.46,28.64",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 448.17,
    y1: 101.01,
    x2: 439.85,
    y2: 82.2,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.71,101.21c-5.34-4.38-9-11.83-8.32-18.8.04-.32.34-.55.66-.5,5.7,3.68,9,12.27,8.58,18.9-.03.44-.57.67-.91.4h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 448.04,
    y1: 101.8,
    x2: 427.41,
    y2: 85.64,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.73,102.2c-8.92-.77-18.14-7.37-20.63-16.17-.09-.34.11-.68.45-.77,9.14.12,17.94,7.68,20.8,16.15.13.4-.2.82-.62.79h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 449.4,
    y1: 101.48,
    x2: 451.86,
    y2: 74.84,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.9,101.43c-3.53-8.12-2.92-19.42,2.46-26.63.2-.26.58-.3.84-.1,4.25,7.76,2.61,19.67-2.3,26.83-.25.35-.82.3-1-.09h0Z",
    fill: "#7db5a9"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M945.58-278.15c5.51-1.96,5.39-20.28-6.58-29.55-1.04-.8-2.52-.23-3.54.59-6.72,5.47-8.62,19.93-5.35,29.16",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 939.6,
    y1: -268.64,
    x2: 938.63,
    y2: -289.53,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.1-268.61c-3.4-6.13-4.12-14.51-.97-20.89.15-.28.51-.39.79-.24,4,5.6,3.96,14.93,1.18,21.08-.18.4-.78.42-1,.05h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 939.19,
    y1: -267.93,
    x2: 925.6,
    y2: -290.83,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.76-267.67c-8.11-4.07-14.39-13.68-13.59-22.91.04-.34.35-.59.69-.55,8.53,3.5,14.11,13.94,13.76,22.95-.02.42-.49.69-.86.51h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 940.59,
    y1: -267.73,
    x2: 952.71,
    y2: -292.09,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.15-267.96c-.3-8.95,4.45-19.47,12.11-24.36.28-.17.64-.08.81.2,1.13,8.85-4.83,19.61-12.03,24.6-.36.24-.88-.02-.9-.45h0Z",
    fill: "#7db5a9"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M543.6-105.85c5.51-1.96,5.39-20.28-6.58-29.55-1.04-.8-2.52-.23-3.54.59-6.72,5.47-8.62,19.93-5.35,29.16",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 537.63,
    y1: -96.33,
    x2: 536.66,
    y2: -117.22,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.13-96.3c-3.4-6.13-4.12-14.51-.97-20.89.15-.28.51-.39.79-.24,4,5.6,3.96,14.93,1.18,21.08-.18.4-.78.42-1,.05h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 537.21,
    y1: -95.62,
    x2: 523.62,
    y2: -118.53,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.78-95.36c-8.11-4.07-14.39-13.68-13.59-22.91.04-.34.35-.59.69-.55,8.53,3.5,14.11,13.94,13.76,22.95-.02.42-.49.69-.86.51h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 538.62,
    y1: -95.43,
    x2: 550.73,
    y2: -119.78,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.17-95.65c-.3-8.95,4.45-19.47,12.11-24.36.28-.17.64-.08.81.2,1.13,8.85-4.83,19.61-12.03,24.6-.36.24-.88-.02-.9-.45h0Z",
    fill: "#7db5a9"
  })))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M-345.56,367.63c49.56-19.78,83.78-67.78,92.44-111.78",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower2);
export default __webpack_public_path__ + "static/media/flower2.100402a4392776f20f651357cb97289a.svg";
export { ForwardRef as ReactComponent };